module.exports = __webpack_public_path__ + "static/media/account-icon.fe8b4e8f.svg";